/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import InputMask from "react-input-mask";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import { formatCnpjCpf, visible, EncrypteValue, } from "../../services/funcoes.js";
import { set_Login, set_Dados, set_DocCliente, set_Cliente, set_ProfCliente, GetApiOut, PostApiOut2, } from "../../services/auth";
import { MDBModal, MDBModalBody, MDBModalFooter, MDBModalHeader, } from "mdbreact";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { Loading } from "../../componentes/Loading";
import { Container, DivVerificaSenha } from "./styles";

import icondanger from "../../assets/imagens/icon-bad.png";
import iconsucess from "../../assets/imagens/icon-check.png";
import olhoAberto from "../../assets/imagens/olho.png";
import olhofechado from "../../assets/imagens/olho-fechado.png";
import { Alert, Card, CardBody, CardFooter, CardHeader, FormLabel, Grid, InputContainer, Section, } from "uikit-react";
import Logo from "../../assets/imagens/logo_de_grao_em_pao_azul.png";

const Index = () => {

  //modal troca senha
  const [modalSenha, SetModalSenha] = useState(false);
  const [password, SetPassword] = useState("");
  const [confirmPassword, SetconfirmPassword] = useState("");
  const [username, SetUsername] = useState("");

  //bloquear botoes
  const [block, SetBlock] = useState("disabled");
  const [blockSenha, SetBlockSenha] = useState("disabled");
  const [blockPassword, SetBlockPassword] = useState("disabled");

  //login
  const [cpf, SetCPF] = useState("");
  const [senha, SetSenha] = useState("");

  //esquece senha
  const [cpfSenha, SetCpfSenha] = useState("");
  const [TokenAlterarSenha, setTokenAlterarSenha] = useState("");

  //primeiro acesso
  const [confirmaSenha, SetConfirmaSenha] = useState("");
  const [TokenCadastro, setTokenCadastro] = useState("");

  //validando senha
  const [senhaOk, SetsenhaOk] = useState(false);
  const [testeSenhaMaius, SettesteSenhaMaius] = useState("dng");
  const [testeSenhaMinus, SettesteSenhaMinus] = useState("dng");
  const [testeSenhaEsp, SettesteSenhaEsp] = useState("dng");
  const [testeSenhaQtd, SettesteSenhaQtd] = useState("dng");
  const [testeSenhaNum, SettesteSenhaNum] = useState("dng");
  const [olho, Setolho] = useState(olhoAberto);


  const [mostraSenhaPrimeiroAcesso, setMostraSenhaPrimeiroAcesso] = useState(false);
  const [mostraSenhaPrimeiroAcesso2, setMostraSenhaPrimeiroAcesso2] = useState(false);
  const [mostraSenhaEsqueciSenha, setMostraSenhaEsqueciSenha] = useState(false);
  const [mostraSenhaEsqueciSenha2, setMostraSenhaEsqueciSenha2] = useState(false);
  const [loadingAcesso, setLoadingAcesso] = useState(false);

  //Alert
  const [msg, SetMsg] = useState("");
  const [time, SetTime] = useState("");
  const [color, SetColor] = useState(""); //sucess, danger, warning
  const [AlertMsg, SetAlertMsg] = useState(false);

  //const [cargo, SetCargo] = useState("");
  //const [status, SetStatus] = useState("");

  const clearCache = async () => {
    console.log('passou clearCache 1');
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
      .getRegistrations()
      .then(function (registrations) {
        for (let registration of registrations) {
          console.log('passou clearCache 2');
          registration.unregister();
          window.localStorage.clear();
          window.location.reload();
        }
      })
    }
  }

  const Logout = async () => {
    window.localStorage.clear();
  };

  const toggleSenha = async (camp) => {
    SetModalSenha(!modalSenha);
  };

  useEffect(() => {

    let url = window.location.href, tipo = "", token = "";
    url = url.split("/");
    tipo = url[4];
    tipo = tipo?.toLocaleLowerCase();
    token = url[5];    

    if(tipo === "cadastro" && token !== undefined){
          setTokenCadastro(token);
          visible("acesso");
          visible("acessoFooter");
          visible("login");
          visible("loginFooter");
    }

    clearCache();
    let prop = document.location.href;
    //console.log('TESTE PROP', prop)
    prop = prop.split("esquecisenha/");
    prop = prop[1];

    if (prop !== "" && prop !== undefined) {
      validaRash(prop);
    } else {
      Logout();
    }

    localStorage.removeItem("token_key_forn");
    localStorage.removeItem("dados_login_forn");
    localStorage.removeItem("cliente_prof_forn");
    localStorage.removeItem("cliente_cod_forn");
    window.localStorage.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (senha.length < 8 || cpf.length < 14) {
      SetBlock("disabled");
    } else {
      SetBlock("");
    }
  }, [senha, cpf]);

  useEffect(() => {
    if (
      password.length < 8 ||
      confirmPassword.length < 8 ||
      password !== confirmPassword ||
      senhaOk === false
    ) {
      SetBlockPassword("disabled");
    } else {
      SetBlockPassword("");
    }
    //console.log("TESTE SENHA OK:", senhaOk);
  }, [password, confirmPassword, senhaOk, senha]);

  useEffect(() => {
    if (cpfSenha.length < 14) {
      SetBlockSenha("disabled");
    } else {
      SetBlockSenha("");
    }
  }, [cpfSenha]);

  useEffect(() => {
    if (senha.length < 8 || cpf === "") {
      SetBlockSenha("disabled");
    } else {
      SetBlockSenha("");
    }
  }, [senha, cpf]);

  const validaRash = async (prop) => {
    visible("LoadingPage");
    const dadoToken = {
      token: prop,
      tipo: 2,
    };
    const response = await PostApiOut2("ValidarToken/ValidarToken", dadoToken);
    console.log("TESTE VALIDA:", response);
    if (response && response.data.sucesso) {
      SetUsername(response.data.documento);
      SetModalSenha(true);
      setTokenAlterarSenha(prop);
      visible("LoadingPage");
    } else {
      visible("LoadingPage");
      Swal.fire({
        icon: "error",
        title: "Atenção!",
        text: response.data.mensagem,
      });
    }
  };

  const Mostrasenha = (id) => {
    const tipo = document.getElementById(id);
    if (tipo.type === "password") {
      tipo.type = "text";
      Setolho(olhofechado);
    } else {
      tipo.type = "password";
      Setolho(olhoAberto);
    }
  };

  const testaSenha = (senha) => {
    let teste = true;
    let letrasMaiusculas = /[A-Z]/;
    let letrasMinusculas = /[a-z]/;
    let numeros = /[0-9]/;
    let caracteresEspeciais = /[!|@|#|$|%|^|&|*|(|)|-|_]/;

    if (caracteresEspeciais.test(senha)) {
      SettesteSenhaEsp("scs");
    } else {
      SettesteSenhaEsp("dng");
      teste = false;
    }
    if (numeros.test(senha)) {
      SettesteSenhaNum("scs");
    } else {
      SettesteSenhaNum("dng");
      teste = false;
    }
    if (letrasMaiusculas.test(senha)) {
      SettesteSenhaMaius("scs");
    } else {
      SettesteSenhaMaius("dng");
      teste = false;
    }
    if (letrasMinusculas.test(senha)) {
      SettesteSenhaMinus("scs");
    } else {
      SettesteSenhaMinus("dng");
      teste = false;
    }
    if (senha.length > 7) {
      SettesteSenhaQtd("scs");
    } else {
      SettesteSenhaQtd("dng");
      teste = false;
    }

    SetsenhaOk(teste);
  };

  const alteraSenha = async () => {   
    visible("novasenha");
    visible("aguardesenha");

    const dados = {
      userId: username,
      userPassword: password,
      token: TokenAlterarSenha,
    };

    const response = await PostApiOut2("GenLogin/NovaSenha", dados);
    console.log("TESTE ALTERA SNEHA:", response);
    if (response.data.sucesso) {
      visible("novasenha");
      visible("aguardesenha");

      SetTime(3000);
      SetMsg("Senha alterada com sucesso");
      SetColor("success");
      SetAlertMsg(true);
      SetModalSenha(false);
    } else {
      visible("novasenha");
      visible("aguardesenha");

      SetTime(8000);
      SetMsg(
        "Não conseguimos alterar sua senha, entre em contato com a central de atendimentos."
      );
      SetColor("danger");
      SetAlertMsg(true);
      SetModalSenha(false);
      return;
    }
  };

  const validaLog = async (e) => {
    let cpfFormat = formatCnpjCpf(cpf);

    visible("cadastrar");
    visible("aguarde");
    setLoadingAcesso(true);

    try {
      const dadosCliente = await GetApiOut("Cliente/ListarClienteDocAnon/" + cpfFormat);
      console.log("TESTE DadosCliente:", dadosCliente);

      // if(dadosCliente.status === 400){
      //   visible("cadastrar");
      //   visible("aguarde");

      //   SetTime(8000);
      //   SetMsg(dadosCliente.data.mensagem);
      //   SetColor("danger");
      //   SetAlertMsg(true);
      //   return;
      // }

      const encryptPass = EncrypteValue(senha);
      const encryptCpf = EncrypteValue(cpfFormat);

      const dados = {
        documento: encryptCpf,
        senha: encryptPass,
      };

      const resForn = await PostApiOut2("Admin/login", dados);
      // const resForn = await PostApiOut2("Logon/Login/", dados);

      console.log("TESTE Login:", resForn);
      
      let msg = resForn.data.mensagem;

      if (resForn.data.sucesso) {
        set_DocCliente(cpf);
        set_Login(resForn.data.token);
       
        const decoded = jwtDecode(resForn.data.token, { complete: true });
        console.log("TESTE decoded:", decoded);

        resForn.data.FullName = decoded.FullName;
        set_Dados(resForn.data);

        var Name = decoded.FullName.split(" ");
        set_Cliente(Name[0]);

        if (dadosCliente.data.sucesso) {
          set_ProfCliente(dadosCliente.data.cargo);
          window.location = "MenuRapido";
        } 

      } else {

        if (msg === "Usuário não encontrado" || msg === "Falha de login") {
          visible("cadastrar");
          visible("aguarde");

          SetCPF("");
          SetSenha("");

          SetTime(8000);
          SetMsg("Você não tem acesso a esta plataforma!");
          SetColor("danger");
          SetAlertMsg(true);
        } else if (msg === "Falha no login, usuário ou senha inválida") {
          SetTime(8000);
          // SetMsg(msg);
          SetMsg('Ops! Seu login ou senha estão incorretos! Verifique e tente novamente.');
          SetColor("danger");
          SetAlertMsg(true);

          visible("cadastrar");
          visible("aguarde");
        } else if(msg === "Precisa fazer o primeiro acesso!") {
          visible("cadastrar");
          visible("aguarde");

          SetTime(10000);
          SetMsg(msg);
          SetColor("danger");
          SetAlertMsg(true);

          visible("acesso");
          visible("acessoFooter");
          visible("login");
          visible("loginFooter");
          SetSenha("");
        } else {
          SetTime(15000);
          SetMsg(msg);
          SetColor("danger");
          SetAlertMsg(true);

          visible("cadastrar");
          visible("aguarde");
        }
      }
    } catch (e) {
      Swal.fire({
        icon: "info",
        title: "Atenção!",
        html: "4Algum erro ocorreu por favor tente novamente." + e,
      });
    } finally{
      setLoadingAcesso(false);
    }
  };

  const EsqueceSenha = async () => {
    let cpfNew = formatCnpjCpf(cpfSenha);

    visible("enviasenha");
    visible("aguardeFooter");

    const encryptCpf = EncrypteValue(cpfNew);

    const dados = {
      cpf: encryptCpf,
      tipoEmail: 3,
      remetente: "contatomercedesclub@omnion.com.br",
      link: "https://www.mercedesclub.com.br/admin/esquecisenha/"     
    };
    const response = await PostApiOut2("EsqueceuSenha/EsqueceuSenha", dados);
    //console.log("TESTE EsqueceuSenha:", response);
    if (response.data.sucesso) {
      visible("enviasenha");
      visible("aguardeFooter");

      SetTime(3000);
      SetMsg(response.data.mensagem);
      SetColor("success");
      SetAlertMsg(true);

      visible("login");
      visible("loginFooter");

      visible("password");
      visible("passwordFooter");
      SetCpfSenha("");
    } else {
      visible("enviasenha");
      visible("aguardeFooter");

      SetTime(8000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);

      SetCpfSenha("");
    }
  };

  const PrimeiroAcesso = async () => {
    let cpfEnv = cpf;
    cpfEnv = formatCnpjCpf(cpf);

    if (senha !== confirmaSenha) {
      SetTime(5000);
      SetMsg("As senhas informadas devem ser iguais!");
      SetColor("danger");
      SetAlertMsg(true);
      return;
    }
    if (!senhaOk) {
      SetTime(5000);
      SetMsg("Por favor, informe uma senha que atenda aos requisitos especificados!");
      SetColor("danger");
      SetAlertMsg(true);
      return;
    }

    visible("LoadingPage");

    const encryptPass = EncrypteValue(senha);
    const encryptCpf = EncrypteValue(cpfEnv);

    const dados = {
      documento: encryptCpf,
      senha: encryptPass,
      token: TokenCadastro,
    };

    const response = await PostApiOut2("Admin/criar-senha", dados);
    //console.log('TESTE:', response)
    if (response.data.sucesso) {
      validaLog();
    } else {
      Swal.fire({
        icon: "info",
        title: "Atenção!",
        html: response.data.mensagem,
      });
    }
    visible("LoadingPage");
  };

  // MODAL VALIDADOR SENHA
  const TesteSenha = (id) => {
    return (
      <>
        <DivVerificaSenha id={id} >
          <div className={testeSenhaMaius}>
            {" "}
            {testeSenhaMaius === "dng" ? (
              <ErrorOutlineIcon />
            ) : (
              <CheckCircleOutlineIcon />
            )}{" "}
            Letra maiúscula{" "}
          </div>
          <div className={testeSenhaMinus}>
            {" "}
            {testeSenhaMinus === "dng" ? (
              <ErrorOutlineIcon />
            ) : (
              <CheckCircleOutlineIcon />
            )}{" "}
            Letra minúscula{" "}
          </div>
          <div className={testeSenhaEsp}>
            {" "}
            {testeSenhaEsp === "dng" ? (
              <ErrorOutlineIcon />
            ) : (
              <CheckCircleOutlineIcon />
            )}{" "}
            Caractere especial{" "}
          </div>
          <div className={testeSenhaNum}>
            {" "}
            {testeSenhaNum === "dng" ? (
              <ErrorOutlineIcon />
            ) : (
              <CheckCircleOutlineIcon />
            )}{" "}
            Número{" "}
          </div>
          <div className={testeSenhaQtd}>
            {" "}
            {testeSenhaQtd === "dng" ? (
              <ErrorOutlineIcon />
            ) : (
              <CheckCircleOutlineIcon />
            )}{" "}
            Mínimo de 8 caracteres{" "}
          </div>
        </DivVerificaSenha>
      </>
    );
  };
  
  // CLICK NO BTN ENTRAR AO PRESSIONAR A TECLA 'ENTER'
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        
        const btnAcessar = document.getElementById('form-btn-acessar');
        btnAcessar.click();
      }
    };
  
    document.addEventListener("keydown", handleKeyDown);
  
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Container className="mais">
      <Loading />

      <div
        className="uk-container uk-flex uk-flex-center uk-flex-middle"
        uk-height-viewport="expand: true"
      >
        <Card className="uk-card uk-card-default uk-width-large">
          <CardHeader>
            <h3 className="uk-card-title uk-text-center">
              Acesso ao Sistema Administrativo
            </h3>
          </CardHeader>

          <CardBody>
            {AlertMsg === true && (
              <Alert
                color={color}
                content={msg}
                duration={time}
                onHide={() => SetAlertMsg(false)}
                isClosable
              />
            )}

            <Grid className="uk-grid-small uk-margin-medium uk-flex uk-flex-center">
              <Section>
                <div
                  className="uk-flex uk-flex-center uk-flex-middle"
                  style={{ width: "150px" }}
                >
                  <img src={Logo} width="100%" alt="Mercedes Club" />
                </div>
              </Section>
            </Grid>

            <Grid className="uk-grid-small uk-child-width-expand@s">
              <Section id="login">
                <Section className="uk-width-1-1@m uk-margin">
                  <InputContainer>
                    <FormLabel className="uk-form-label">Login</FormLabel>
                    <InputMask
                      mask="999.999.999-99"
                      maskChar=""
                      className="uk-input input"
                      type="text"
                      value={cpf}
                      placeholder="Informe seu CPF"
                      onChange={(e) => {
                        SetCPF(e.target.value);
                      }}
                    />
                  </InputContainer>
                </Section>

                <Section className="uk-width-1-1@m uk-margin">
                  <InputContainer style={{ position: "relative" }}>
                    <FormLabel className="uk-form-label">Senha</FormLabel>
                    <input
                      type="password"
                      name="password"
                      className="uk-input input"
                      placeholder="Informe sua senha"
                      value={senha}
                      onChange={(e) => SetSenha(e.target.value)}
                      id="olho"
                    />
                    <img
                      src={olho}
                      className="olho"
                      alt="Ver senha"
                      onClick={() => Mostrasenha("olho")}
                    />
                  </InputContainer>
                </Section>
              </Section>

              <Section id="password">
                <Section className="uk-width-1-1@m">
                  <InputContainer style={{ position: "relative" }}>
                    <FormLabel className="uk-form-label">
                      Digite o CPF para recuperar a senha
                    </FormLabel>
                    <InputMask
                      mask="999.999.999-99"
                      maskChar=""
                      type="text"
                      className="uk-input input"
                      value={cpfSenha}
                      placeholder="Informe seu CPF"
                      onChange={(e) => {
                        SetCpfSenha(e.target.value);
                      }}
                    />
                  </InputContainer>
                </Section>
              </Section>

              <Section id="acesso">
                <CardHeader className="uk-margin-small-bottom">
                  <h2 className="uk-card-title">Meu 1º Acesso</h2>
                </CardHeader>

                <Section className="uk-width-1-1@m uk-margin">
                  <InputContainer>
                    <FormLabel className="uk-form-label">
                      Informe seu CPF
                    </FormLabel>
                    <InputMask
                      mask="999.999.999-99"
                      maskChar=""
                      type="text"
                      value={cpf}
                      className="uk-input input"
                      placeholder="Informe seu CPF"
                      onChange={(e) => {
                        SetCPF(e.target.value);
                      }}
                    />
                  </InputContainer>
                </Section>

                <Section className="uk-width-1-1@m uk-margin">
                  <InputContainer style={{ position: "relative" }}>
                    <FormLabel className="uk-form-label">
                      Crie sua senha
                    </FormLabel>
                    <input
                      type={mostraSenhaPrimeiroAcesso ? "text" : "password"}
                      name="password"
                      className="uk-input input"
                      placeholder="Crie sua senha"
                      onFocus={() => visible("Senha")}
                      onBlur={() => visible("Senha")}
                      value={senha}
                      onChange={(e) => {
                          SetSenha(e.target.value);
                          testaSenha(e.target.value);
                        }
                      }
                    />
                    <img
                      src={mostraSenhaPrimeiroAcesso ? olhoAberto : olhofechado}
                      className="olho"
                      alt="Ver senha"
                      onClick={() => setMostraSenhaPrimeiroAcesso(prev => !prev)}
                    />
                    {/* MODAL TESTA SENHA  */}
                  </InputContainer>
                  {TesteSenha("Senha")}
                </Section>

                <Section className="uk-width-1-1@m uk-margin">
                  <InputContainer style={{ position: "relative" }}>
                    <FormLabel className="uk-form-label">
                      Repita sua senha
                    </FormLabel>
                    <input
                      type={mostraSenhaPrimeiroAcesso2 ? "text" : "password"}
                      name="password"
                      className="uk-input input"
                      placeholder="Repita sua senha"
                      value={confirmaSenha}
                      onChange={(e) => SetConfirmaSenha(e.target.value)}
                    />
                    <img
                      src={mostraSenhaPrimeiroAcesso2 ? olhoAberto : olhofechado}
                      className="olho"
                      alt="Ver senha"
                      onClick={() => setMostraSenhaPrimeiroAcesso2(prev => !prev)}
                    />
                  </InputContainer>
                </Section>
              </Section>
            </Grid>
          </CardBody>

          <CardFooter>
            <span id="loginFooter">
              <Grid className="uk-child-width-expand@s">
                <Section className="uk-margin-small-top">
                  <div
                    onClick={() => {
                      visible("password");
                      visible("passwordFooter");
                      visible("login");
                      visible("loginFooter");
                    }}
                    className="uk-link"
                  >
                    Esqueceu a senha?
                  </div>
                </Section>

                <Section id="cadastrar">
                  <button
                    id='form-btn-acessar'
                    className="uk-button uk-button-primary uk-float-right"
                    type="button"
                    onClick={() => validaLog()}
                    disabled={block || loadingAcesso}
                  >
                    <span
                      className="uk-margin-small-right"
                      uk-icon="icon: check"
                    ></span>
                    Entrar
                  </button>
                </Section>

                <Section id="aguarde">
                  <a
                    href="#!"
                    className="uk-button uk-button-primary uk-disabled uk-float-right"
                  >
                    <span
                      uk-spinner="ratio: 0.5"
                      className="uk-margin-small-right"
                    ></span>
                    Aguarde
                  </a>
                </Section>
              </Grid>
            </span>

            <span id="passwordFooter">
              <Grid className="uk-child-width-expand@s">
                <Section className="uk-margin-small-top">
                  <div
                    onClick={() => {
                      visible("password");
                      visible("login");
                      visible("loginFooter");
                      visible("passwordFooter");
                    }}
                    className="uk-link"
                  >
                    {"< Voltar ao login"}
                  </div>
                </Section>

                <Section id="enviasenha">
                  <button
                    className="uk-button uk-button-primary uk-float-right"
                    type="button"
                    onClick={() => EsqueceSenha()}
                    value="Enviar"
                    disabled={blockSenha}
                  >
                    <span
                      className="uk-margin-small-right"
                      uk-icon="icon: check"
                    ></span>
                    Enviar
                  </button>
                </Section>

                <Section id="aguardeFooter">
                  <a
                    href="#!"
                    className="uk-button uk-button-primary uk-disabled uk-float-right"
                  >
                    <span
                      uk-spinner="ratio: 0.5"
                      className="uk-margin-small-right"
                    ></span>
                    Aguarde
                  </a>
                </Section>
              </Grid>
            </span>

            <span id="acessoFooter">
              <Grid>
                <Section className="uk-width-1-3@m uk-margin-small-top">
                  <div
                    className="uk-link"
                    onClick={() => {
                      visible("login");
                      visible("loginFooter");
                      visible("acesso");
                      visible("acessoFooter");
                    }}
                  >
                    Voltar ao login!
                  </div>
                </Section>

                <Section className="uk-width-2-3@m">
                  <button
                    className="uk-button uk-button-primary uk-float-right"
                    type="button"
                    onClick={() => PrimeiroAcesso()}
                    disabled={blockSenha}
                  >
                    <span
                      className="uk-margin-small-right"
                      uk-icon="icon: check"
                    ></span>
                    Entrar
                  </button>
                </Section>
              </Grid>
            </span>
          </CardFooter>
        </Card>
      </div>

      {/* MODAL senha */}
      <MDBModal isOpen={modalSenha} 
        // toggle={() => 
        // toggleSenha()} 
        size="md"
        centered
      >
        <MDBModalHeader toggle={() => toggleSenha()}>
          Redefinir Senha
        </MDBModalHeader>
        
        <MDBModalBody>
          <Card>
            {AlertMsg === true && (
              <Alert
                color={color}
                content={msg}
                duration={time}
                onHide={() => SetAlertMsg(false)}
                isClosable
              />
            )}

            <CardBody>
              <Grid className="uk-grid-small uk-child-width-expand@s">
                <Section className="uk-width-1-1@m">
                  <InputContainer style={{ position: "relative" }}>
                    <FormLabel className="uk-form-label">
                      Digite sua Nova Senha
                    </FormLabel>
                    <input
                      type={mostraSenhaEsqueciSenha ? "text" : "password"}
                      name="senha"
                      className="uk-input input"
                      maxLength="30"
                      value={password}
                      onFocus={() => visible("redefinir-senha")}
                      onBlur={() => visible("redefinir-senha")}
                      onChange={async (e) => {
                        SetPassword(e.target.value);
                        testaSenha(e.target.value);
                      }}
                    />

                    <img
                      src={mostraSenhaEsqueciSenha ? olhoAberto : olhofechado}
                      className="olho"
                      alt=""
                      onClick={() => setMostraSenhaEsqueciSenha(prev => !prev)}
                    />
                  </InputContainer>
                  {TesteSenha("redefinir-senha")}
                </Section>

                <Section className="uk-width-1-1@m">
                  <InputContainer style={{ position: "relative" }}>
                    <FormLabel className="uk-form-label">
                      Informe novamente a Nova Senha
                    </FormLabel>
                    <input
                      name="confirmacao"
                      type={mostraSenhaEsqueciSenha2 ? "text" : "password"}
                      maxLength="30"
                      className="uk-input input"
                      autoComplete="off"
                      alt="#"
                      value={confirmPassword}
                      onChange={(e) => {
                        SetconfirmPassword(e.target.value);
                      }}
                    />
                    <img
                      src={mostraSenhaEsqueciSenha2 ? olhoAberto : olhofechado}
                      className="olho"
                      alt=""
                      onClick={() => setMostraSenhaEsqueciSenha2(prev => !prev)}
                    />
                  </InputContainer>
                  <small>As senhas precisam ser iguais</small>
                </Section>
              </Grid>
            </CardBody>
          </Card>
        </MDBModalBody>
        
        <MDBModalFooter>
          <button
            className="uk-button uk-button-primary"
            type="button"
            onClick={() => alteraSenha()}
            id="novasenha"
            disabled={blockPassword}
          >
            <span
              className="uk-margin-small-right"
              uk-icon="icon: check"
            ></span>
            Enviar nova senha
          </button>

          <a
            href="#!"
            className="uk-button uk-button-primary uk-disabled"
            id="aguardesenha"
          >
            <span
              uk-spinner="ratio: 0.5"
              className="uk-margin-small-right"
            ></span>
            Aguarde
          </a>
        </MDBModalFooter>
        
      </MDBModal>
    </Container>
  );
};

export default Index;
